export default __webpack_public_path__ + "static/media/logo.003c2f45.svg";